import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { initials } from '../../../core/utils/format.util';
import { brandTint } from '../../../core/utils/color.util';

/** «Logo de negocio»: cuadrado (pines, avatares, chips) u horizontal (encabezados). Fallback = iniciales sobre tinte. */
@Component({
  selector: 'app-business-logo',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.is-horizontal]': "format() === 'horizontal'",
    '[style.--s]': "size() + 'px'",
    '[style.--r]': "radius() + 'px'",
    '[style.background]': 'url() ? null : tint().bg',
    '[style.color]': 'tint().ink',
  },
  template: `
    @if (url()) { <img [src]="url()" [alt]="name()" loading="lazy" /> }
    @else { <span>{{ format() === 'horizontal' ? name() : letters() }}</span> }
  `,
  styles: [`
    :host{width:var(--s);height:var(--s);border-radius:var(--r);display:grid;place-items:center;overflow:hidden;flex:none;
      font:800 calc(var(--s) * .4)/1 var(--cr-font-display);letter-spacing:-.04em;background:var(--cr-bg-surface-2)}
    :host(.is-horizontal){width:calc(var(--s) * 3);font-size:calc(var(--s) * .3);padding:0 8px;text-align:center}
    img{width:100%;height:100%;object-fit:cover}
    :host(.is-horizontal) img{object-fit:contain}
    span{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:100%}
  `],
})
export class BusinessLogoComponent {
  readonly name = input<string>('');
  readonly url = input<string | null | undefined>(null);
  readonly format = input<'square' | 'horizontal'>('square');
  readonly size = input<number>(32);
  readonly radius = input<number>(8);
  /** `brandColor` de la API: tiñe el fallback de iniciales con el color de marca del negocio. */
  readonly brandColor = input<string | null | undefined>(null);
  readonly letters = computed(() => initials(this.name()));
  readonly tint = computed(() => brandTint(this.brandColor(), this.name()));
}
